import { render, staticRenderFns } from "./form-message.vue?vue&type=template&id=4f3b0ff9&"
import script from "./form-message.vue?vue&type=script&lang=js&"
export * from "./form-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-message.vue"
export default component.exports